module.exports = __webpack_public_path__ + "img/61.d4509109.jpg";